import type { Ref } from "vue";

// Union matches the project's configured locales — switchLocalePath() requires it
type LocaleCode = "en" | "ru" | "ka";
type LocaleEntry = LocaleCode | { code: LocaleCode; language?: string };
type I18nLike = {
  locales: Ref<LocaleEntry[]>;
  defaultLocale: LocaleCode;
};

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = nuxtApp.$i18n as I18nLike | undefined;
  if (!i18n) return;
  const switchLocalePath = useSwitchLocalePath();
  const baseUrl = "https://georgiadream.ge";
  const locales = i18n.locales;
  const defaultLocale = i18n.defaultLocale;

  useHead({
    link: computed(() => {
      const out: { rel: string; hreflang: string; href: string }[] = [];

      const stripQuery = (p: string) => p.split("?")[0].split("#")[0];

      for (const l of locales.value) {
        const code = typeof l === "object" ? l.code : l;
        // `language` is the i18n v10 field name (`iso` was its deprecated alias)
        const hreflang = (typeof l === "object" ? l.language : null) || code;
        const path = switchLocalePath(code);
        if (!path) continue;
        out.push({
          rel: "alternate",
          hreflang,
          href: `${baseUrl}${stripQuery(path)}`,
        });
      }

      const defaultPath = switchLocalePath(defaultLocale);
      if (defaultPath) {
        out.push({
          rel: "alternate",
          hreflang: "x-default",
          href: `${baseUrl}${stripQuery(defaultPath)}`,
        });
      }

      return out;
    }),
  });
});
